module.exports = __webpack_public_path__ + "img/namecardai-logo.7aa16a0a.png";